export default __webpack_public_path__ + "static/media/wireframe2.8b7955d6.svg";